<!--Copy right - © 2024 tecera gmbh-->
<script>
    export let label;
    export let func;
    export let id="button";
</script>

<button class="btn btn-primary btn-distance text-button"  on:click={func}
    ><i class="fa-solid fa-plus"></i>&nbsp;<span class="new-device-text" style="{id=="hymo_new_device_button" ? "padding-right:1px;" : ""}">&nbsp;{label}</span></button
>
